import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { GSDevTools } from 'gsap/GSDevTools'

gsap.registerPlugin(CSSRulePlugin)

if (window.Environment === 'dev') {
  gsap.registerPlugin(GSDevTools)
}
const observerOptions = {
  root: null,
  rootMargin: '0px 0px',
  threshold: 0.5,
}

export default class HeroAnimation {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.debug = false
    this.heading1 = this.el.querySelector("[data-anim='heading-1']")
    this.heading2 = this.el.querySelector("[data-anim='heading-2']")
    this.message = this.el.querySelector("[data-anim='message']")
    this.cta = this.el.querySelector("[data-anim='cta']")
    this.image = this.el.querySelector("[data-anim='image']")
    this.square = this.el.querySelector("[data-anim='square']")
    this.texture = this.el.querySelectorAll("[data-anim='texture']")
    this.animscreen = this.el.querySelector('.anim-hidden')
    this.flourish = this.el.querySelector("[data-anim='heading-flourish']")
    this.nav = this.el.querySelectorAll("[data-anim='nav']")
  }

  init() {
    this.fadeElements()
    this.parallax()
  }

  parallax() {
    // prettier-start-ignore
    const myTimeline = gsap
      .timeline({ paused: true, ease: 'none' })
      .fromTo(this.flourish, { y: -400 }, { y: 300 }, '<')
      .fromTo(this.square, { y: -280 }, { y: 90 }, '<')
    // prettier-end-ignore

    const progressTween = () => {
      // Get scroll distance to bottom of viewport.
      const scrollPosition = window.scrollY + window.innerHeight
      // Get element's position relative to bottom of viewport.
      const elPosition = scrollPosition - this.el.offsetTop
      // Set desired duration.
      const durationDistance = window.innerHeight + this.el.offsetHeight
      // Calculate tween progress.
      const currentProgress = elPosition / durationDistance
      myTimeline.progress(currentProgress)
    }

    const heroObserver = new IntersectionObserver((entry) => {
      if (entry[0].intersectionRatio > 0) {
        gsap.ticker.add(progressTween)
      } else {
        gsap.ticker.remove(progressTween)
      }
    }, observerOptions)
    heroObserver.observe(this.el)
  }

  fadeElements() {
    const t1 = gsap.timeline({
      defaults: { duration: 0.6, opacity: 0, ease: 'power2.out' },
      id: 'HeroFade',
    })

    let flourishPieces = null
    if (this.flourish) {
      flourishPieces = this.flourish.querySelectorAll('span')
    }
    if (window.Environment === 'dev' && this.debug) {
      GSDevTools.create({ animation: t1 })
    }
    t1.from(this.animscreen, { autoAlpha: 0, duration: 0.1 })
      .fromTo(
        flourishPieces,
        {
          opacity: 0,
          y: '+=60',
        },
        {
          opacity: 0.13,
          y: 0,
          stagger: 0.2,
          duration: 0.7,
          ease: 'power3.out',
        },
      )
      .to(
        flourishPieces,
        {
          opacity: 0.03,
        },
        '=+0.8',
      )
      .from(this.heading1, { opacity: 0, y: '-=60' }, '=-.3')
      .from(this.heading2, { opacity: 0, y: '-=50' }, '=-.5')
      .from(
        this.image,
        { opacity: 0, duration: 1.5, ease: 'power1.in' },
        '=-.5',
      )
      .from(this.message, { opacity: 0, y: '-=40' }, '=-1.4')
      .from(this.cta, { opacity: 0, y: '-=30' }, '=-1.1')
      .from(
        this.nav,
        { yPercent: '100', opacity: 0, stagger: 0.1 },
        '=-.6',
      )
      .to(
        flourishPieces,
        {
          opacity: 0.02,
          duration: 1,
        },
        '=+0.8',
      )

    return t1
  }

  splitOnSpan(elem) {
    return elem
  }
}
